/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 */

import Layout from 'components/Layout';
import Container from 'components/Container';
import Header from 'components/Header';
import TitleAndMetaTags from 'components/TitleAndMetaTags';
import React from 'react';
import {urlRoot} from 'site-constants';
import {sharedStyles} from 'theme';

import names from '../../content/ringraziamenti.yml';

const Ringraziamenti = ({data, location}) => (
  <Layout location={location}>
    <Container>
      <div css={sharedStyles.articleLayout.container}>
        <div css={sharedStyles.articleLayout.content}>
          <Header>Ringraziamenti</Header>
          <TitleAndMetaTags
            canonicalUrl={`${urlRoot}/ringraziamenti.html`}
            title="Milani - Ringraziamenti"
          />

          <div css={sharedStyles.markdown}>
            <p>Ringraziamo qui i nostri gentili cooperatori:</p>

            <ul
              css={{
                display: 'flex',
                flexWrap: 'wrap',
              }}>
              {names.map((name, index) => (
                <li
                  css={{
                    flex: '1 0 200px',
                  }}
                  key={index}>
                  {name}
                </li>
              ))}
            </ul>

            <p>Siamo inoltre grati a:</p>
            <ul>
              <li>
                <a href="https://github.com/nomecognome--">Nome Cognome</a> per averci concesso l'uso del nome del package{' '}
                <a href="https://www.npmjs.com/package/pacchetto--">Pacchetto</a> in npm.
              </li>
              <li>
                <a href="https://nomecognome--.net/">Nome Cognome</a> per averci concesso l'uso del nome del domain{' '}
                <a href="https://qwertyuiop--.abc/">qwertyuiop.abc</a> e lo username
                <a href="https://twitter.com/usernamenomecognome-">@usernamenomecognome</a> in Twitter.
              </li>
              <li>
                <a href="https://github.com/ProjectFoo-">ProjectFoo</a> per
                averci concesso l'uso del nome del package{' '}
                <a href="https://www.npmjs.com/package/foo--">Pacchetto</a> in npm.
              </li>
              <li>
                Nome Cognome per averci permesso di utilizzare{' '}
                <a href="https://github.com/GitttttFoo--">GitFoo</a> in GitHub.
              </li>
              <li>
                <a href="https://github.com/nomecognome--">Nome Cognome</a>{' '}
                per averci permesso di usare il colore dello schema{' '}
                <a href="https://labs.nomecognome.dev/schema--/">
                  Schema
                </a>{' '}
                in questo website.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Container>
  </Layout>
);

export default Ringraziamenti;
